import {
  CTA_UNLOCK_YOUR_OFFER,
  DISCLAIMER_CONSULTATION_CANCEL,
} from 'consts/copy';

import type { FaqProps } from '..';

export const FAQ_PRODUCTS_CUSTOM_FORMULA_CONTENT: FaqProps = {
  header: 'FAQs',
  faqs: [
    {
      question: 'How is the Custom Formula personalized?',
      answer:
        'Your Curology dermatology provider prescribes you a formula containing up to 3 active ingredients, based on your skin quiz and photos. Your formula will target your specific skin concerns and can evolve with you over time!',
    },
    {
      question: 'When will you see results?',
      answer:
        'With consistent use, many patients using these types of ingredients notice a difference within 6-12 weeks—but everyone’s skin is different, so this timeline might vary for you. It’s also important to remember that this is a long-term journey! We’re not just going for progress, but also prevention.',
    },
    {
      question: 'Do you need to wash the Custom Formula off?',
      answer:
        'Nope! Apply your Custom Formula before bed, leave it on while you sleep, and let it do its work overnight.',
    },
  ],
  hideMobileCtaButton: true,
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_OFFER,
    disclaimerText: DISCLAIMER_CONSULTATION_CANCEL,
  },
};
